import { inject, Injectable } from '@angular/core';
import { ChatDbService } from 'src/app/shared/services/chat/data/chat-db.service';
import { PushMarkerService } from '../push/push-marker.services';

import { ChatMessage } from './data/db-schema';
import { Chat } from './model/chat-instance';
import { TWILIO_AGENT_TOKEN } from './twillio/agent-twilio.factory';
import { TwilioChatSendService } from './twillio/twilio-chat-send.service';
import { TwilioToChatDtoHelpersService } from './twillio/twilio-to-chat-dto-helpers';

@Injectable({
  providedIn: 'root',
  // factory needed because with "useClass" it would not inject the twilio token properly
  useFactory: () =>
    new TwilioChatSendService(
      inject(TWILIO_AGENT_TOKEN),
      inject(TwilioToChatDtoHelpersService),
      inject(ChatDbService),
      inject(PushMarkerService)
    ),
})
export abstract class ChatSendService {
  public abstract fetchMessagesOfConversation(
    conversationSid: string,
    anchor: number,
    count: number
  ): Promise<ChatMessage[]>;
  public abstract sendMessage(
    conversationId: string,
    messageBody: string,
    attributes: {},
    chat?: Chat
  ): Promise<ChatMessage>;
  public abstract setAgentConsumptionIndex(conversationId: string, index: number): Promise<void>;

  public abstract updateConversationAttributes(conversationSid: string, attributes?: Object): Promise<void>;
}
